module.exports = __webpack_public_path__ + "media/assets/blue-clock-312419a702e4f965cbd88e7acd7edf5256affd0d0e4d1afa460849b39cdeb2ea.svg";